var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-grow-1 justify-center align-content-center"},[(_vm.authenticated || _vm.isAuth)?_c('Menu'):_vm._e(),_c('router-view'),_c('Modal'),_c('SnackbarNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }